import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { FlowerFidgetBlockComponent } from './FlowerFidgetBlockComponent';
import { FlowerFidgetBlockProps } from './FlowerFidgetBlock';

const FlowerFidgetBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  FlowerFidgetBlockComponent,
);
export type FlowerFidgetBlockEntity = EntityType<
  typeof FlowerFidgetBlockEntityDef
>;

export function _spawnFlowerFidgetBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: FlowerFidgetBlockProps,
  position: Vector2,
): FlowerFidgetBlockEntity {
  const entity = _spawnBaseBlockEntity(
    FlowerFidgetBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockFlowerFidget: {
        props: props,
        option: def.option,
      },
    },
  );
  entity.c.view2d.view.addChild(entity.c.blockFlowerFidget.view);
  return entity;
}
